import React from 'react';
import { Button, SaveButton, Toolbar } from 'react-admin';
import IconCancel from '@material-ui/icons/Cancel';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 16px',
  },
  marginleft5: { marginLeft: '5px' },
}));

const EditToolbar = ({ setOpenEdit = null, pristine, ...props }) => {
  const classes = useStyles();
  return (
    <Toolbar {...props} className={classes.modalFooter}>
      {setOpenEdit && (
        <Button label="ra.action.cancel" onClick={() => setOpenEdit(false)}>
          <IconCancel />
        </Button>
      )}
      <SaveButton className={classes.marginleft5} disabled={pristine} />
    </Toolbar>
  );
};
export default EditToolbar;
